import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { DaemonApiError, useDaemon } from '@diwata/hearth'
import type { OverviewFeedsResponse } from '@/api/feeds'

/**
 * The composite overview feed. The daemon caches each section server-side
 * (stale-while-refresh), so a steady poll here stays cheap.
 */
export function useOverviewFeeds(options?: {
  refetchInterval?: number
}): UseQueryResult<OverviewFeedsResponse> {
  const transport = useDaemon()
  return useQuery({
    queryKey: ['apex', 'overview-feeds'],
    refetchInterval: options?.refetchInterval,
    queryFn: async (): Promise<OverviewFeedsResponse> => {
      const res = await transport.get<OverviewFeedsResponse>('/overview/feeds')
      if (res.status < 200 || res.status >= 300) {
        throw new DaemonApiError('/overview/feeds', res.status, res.familiar)
      }
      return res.body_json
    },
  })
}
